export { Bicycle as default } from './Bicycle';
